import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_point",
  "use": "icon-icon_point-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_point\">\n    <ellipse opacity=\"0.3\" cx=\"8.25\" cy=\"8\" rx=\"8.25\" ry=\"8\" />\n    <ellipse opacity=\"0.7\" cx=\"8.25\" cy=\"8\" rx=\"4.125\" ry=\"4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol